import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/client/query',
    method: 'get',
    params
  })
}


